<template>
  <div class="program-list">
    <h2>{{ $t("reservation.availablePrograms") }}</h2>
    <ProgramList :programs="programs" />
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin";
import ProgramList from "../../components/NewReservation/ProgramList.vue";

export default {
  name: "ProgramsView",
  mixins: [GlobalMixin],
  components: { ProgramList },
  data() {
    return {
      programs: [],
    };
  },
  /**
   * Initialize component
   */
  mounted() {
    // Get all programs
    this.getPrograms();
  },
  methods: {
    /**
     * Get all programs for a specifi tutor
     */
    getPrograms() {
      this.axios(`${process.env.VUE_APP_APIEndPoint}tutor/programs/`).then(
        (res) => (this.programs = res.data)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.program-list {
  margin-top: 36px;
  font-family: $font-family;
  font-style: normal;
  h2 {
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.4375rem;
    color: $title;
    margin-bottom: 16px;
  }
}
</style>
